export const HOMEPAGE_REVIEWS = {
  headingLine1: 'Over 30,000',
  headingLine2Accent: '5-star',
  headingLine2Rest: ' reviews',
}

export const RECIPE_VIDEOS = [
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt55597cd1408553e0/6a6ca9ebe80c445ba3ab6543/green_goodness_bowl.mp4',
    recipeName: 'Green Goodness Bowl With Boiled Egg And Sweet Potato',
    rating: '4.5',
    tile: 'green_goodness',
  },
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt1acec7383b66ebad/6a6ca9d5c1b22514108ed607/fish_and_chips_and_crushed_peas.mp4',
    recipeName: 'Ultimate Fish & Chips With Stout-Battered Sole And Crushed Peas',
    rating: '4.6',
    tile: 'fish_and_chips',
  },
  {
    videoURL:
      'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt8955d60aa256a135/6a6caa5189fd32192f19a207/slow_cooked_beef_brisket_birra_tacos.mp4',
    recipeName: 'Slow Cooked Beef Brisket Birria Tacos',
    rating: '5.0',
    tile: 'beef_brisket',
  },
]
